import { useModal } from '@billy/design-system'

import { ModalId } from '../../../enums/modalId'

export const useIsDemoInvoiceModalOpen = (): boolean => {
  const { isOpen: isCompletedModalOpen } = useModal(ModalId.DemoInvoiceCompletedModal)
  const { isOpen: isSendAsEmailModalOpen } = useModal(ModalId.DemoInvoiceSendAsEmailModal)
  const { isOpen: isSendAsEInvoiceModalOpen } = useModal(ModalId.DemoInvoiceSendAsEInvoiceModal)

  return isCompletedModalOpen || isSendAsEmailModalOpen || isSendAsEInvoiceModalOpen
}
